import styled from 'styled-components';

export const FieldWrapper = styled.div`
  display: flex;
`;

export const DatePartWrapper = styled.div`
  input[name$='[day]'],
  input[name$='[month]'] {
    width: 3.375rem;
    margin-right: 1rem;
  }

  input[name$='[year]'] {
    width: 6.75rem;
  }
`;
